module.exports = __webpack_public_path__ + "media/recipes/145-bdfaec58.png";